export { CMOCEAN }

/**
 * Collection of color scales for the
 * layer styling
 * 
 * @author rhess <robin.hess@awi.de>
 * @memberof vef.ui.color
 */
const CMOCEAN = {
	"algae": [
		{
			"value": 0.0,
			"color": "#d6f9cf",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#84c379",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#11934f",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#185a3a",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#112414",
			"opacity": 1.0
		}
	],
	"amp": [
		{
			"value": 0.0,
			"color": "#f1ecec",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#d7a290",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#bf583a",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#8e1028",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#3c0911",
			"opacity": 1.0
		}
	],
	"balance": [
		{
			"value": 0.0,
			"color": "#171c42",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#3887b9",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#f0eceb",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#bf573a",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#3c0911",
			"opacity": 1.0
		}
	],
	"curl": [
		{
			"value": 0.0,
			"color": "#330d35",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#c25860",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#fdf5f3",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#2c947f",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#141d43",
			"opacity": 1.0
		}
	],
	"deep": [
		{
			"value": 0.0,
			"color": "#fdfdcc",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#77cda2",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#488d9d",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#404c8a",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#271a2c",
			"opacity": 1.0
		}
	],
	"dense": [
		{
			"value": 0.0,
			"color": "#e6f0f0",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#86b9e2",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#7771d5",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#6e2d83",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#360e24",
			"opacity": 1.0
		}
	],
	"diff": [
		{
			"value": 0.0,
			"color": "#07223f",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#748897",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#f5f1ef",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#8c805b",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#1c2206",
			"opacity": 1.0
		}
	],
	"gray": [
		{
			"value": 0.0,
			"color": "#fefefd",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#b2b1b0",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#717170",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#373636",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#000000",
			"opacity": 1.0
		}
	],
	"haline": [
		{
			"value": 0.0,
			"color": "#fdee99",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#7acb66",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#3b9387",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#0f5b90",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#29186b",
			"opacity": 1.0
		}
	],
	"ice": [
		{
			"value": 0.0,
			"color": "#eafcfd",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#7abed0",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#427ab7",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#383874",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#030512",
			"opacity": 1.0
		}
	],
	"matter": [
		{
			"value": 0.0,
			"color": "#fdedb0",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#f19466",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#ce4356",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#821b62",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#2f0f3d",
			"opacity": 1.0
		}
	],
	"rain": [
		{
			"value": 0.0,
			"color": "#eeedf2",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#b5b28a",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#3c8e6d",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#145666",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#211a38",
			"opacity": 1.0
		}
	],
	"solar": [
		{
			"value": 0.0,
			"color": "#e0fd4a",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#d3ab23",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#b66413",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#822c22",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#331317",
			"opacity": 1.0
		}
	],
	"speed": [
		{
			"value": 0.0,
			"color": "#fefccd",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#c9ba44",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#5f910c",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#0b5e2c",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#172312",
			"opacity": 1.0
		}
	],
	"tempo": [
		{
			"value": 0.0,
			"color": "#fef5f4",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#a1c1a1",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#2a937f",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#1a5867",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#141d43",
			"opacity": 1.0
		}
	],
	"thermal": [
		{
			"value": 0.0,
			"color": "#e7fa5a",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#f99341",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#b05f81",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#563b9c",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#032333",
			"opacity": 1.0
		}
	],
	"turbid": [
		{
			"value": 0.0,
			"color": "#e8f5ab",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#c9ad57",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#a16f3b",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#624533",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#221e1b",
			"opacity": 1.0
		}
	]
};

export const VIRIDIS = {
	"viridis": [
		{
			"value": 0.0,
			"color": "#fde724",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#5ec961",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#20908c",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#3a528b",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#440154",
			"opacity": 1.0
		}
	],
	"magma": [
		{
			"value": 0.0,
			"color": "#fbfcbf",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#fb8861",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#b63679",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#50127b",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#000003",
			"opacity": 1.0
		}
	],
	"inferno": [
		{
			"value": 0.0,
			"color": "#fcfea4",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#f98e08",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#bb3754",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#570f6d",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#000003",
			"opacity": 1.0
		}
	],
	"plasma": [
		{
			"value": 0.0,
			"color": "#eff821",
			"opacity": 1.0
		},
		{
			"value": 0.25,
			"color": "#f89540",
			"opacity": 1.0
		},
		{
			"value": 0.5,
			"color": "#cb4777",
			"opacity": 1.0
		},
		{
			"value": 0.75,
			"color": "#7e03a7",
			"opacity": 1.0
		},
		{
			"value": 1.0,
			"color": "#0c0786",
			"opacity": 1.0
		}
	]
};